export const getDefaultHeaders = (token = null) => {
    return {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
    }
};
